import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { medicalKeys } from '../queries/keys';
import { medicalPaths } from '../queries/paths';

// TSS vite/03 — log de salud (admin-medical-events.md). Lista por sujeto (animal_id
// XOR recipient_id) — el panel se monta en el detalle del animal / de la receptora.
export function useMedicalEventsList(filters) {
    return useQuery({
        queryKey: medicalKeys.list(filters),
        queryFn:  ({ signal }) => api.get(medicalPaths.list(), { params: filters, signal }).then(r => r.data),
        enabled:  !!(filters?.animal_id || filters?.recipient_id),
        placeholderData: (prev) => prev,
    });
}

// TSS vite/03 — alta de evento médico (admin-medical-events.md). Sujeto polimórfico
// (animal_id XOR recipient_id). Un evento `abortion`/`embryonic_loss` con pregnancy_id
// transiciona esa preñez a `lost` → se invalidan preñeces, sesiones TE y KPIs.
export function useCreateMedicalEvent() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(medicalPaths.list(), payload).then(r => r.data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: medicalKeys.all });
            qc.invalidateQueries({ queryKey: ['pregnancies'] });
            qc.invalidateQueries({ queryKey: ['transfer-sessions'] });
            qc.invalidateQueries({ queryKey: ['opu'] });
            qc.invalidateQueries({ queryKey: ['kpis'] });
        },
    });
}
